import request from '@/utils/request'
import { v2Host } from '@/config/host'

// mindwork 博客接口
// http://playable.dev.com:8067/?doc=website/blog.go

// 创建
export function creatBlog(data) {
  return request({
    url: `${v2Host}/website/blog/create`,
    method: 'post',
    data: data,
  })
}

// 删除
export function deleteBlog(id, data) {
  return request({
    url: `${v2Host}/website/blog/delete?id=${id}`,
    method: 'post',
    data: data,
  })
}

// 发布
export function publishBlog(id, data) {
  return request({
    url: `${v2Host}/website/blog/publish?id=${id}`,
    method: 'post',
    data: data,
  })
}

// 更新
export function updateBlog(id, data) {
  return request({
    url: `${v2Host}/website/blog/update?id=${id}`,
    method: 'post',
    data: data,
  })
}

// stick
export function stickBlog(id, data) {
  return request({
    url: `${v2Host}/website/blog/stick?id=${id}`,
    method: 'post',
    data: data,
  })
}

// fetch blog list
export function fetchBlogList(params) {
  return request({
    url: `${v2Host}/website/blog/list`,
    method: 'get',
    params: params,
  })
}

// fetch blog Info
export function fetchBlogInfo(id, params) {
  return request({
    url: `${v2Host}/website/blog/info?id=${id}`,
    method: 'get',
    params: params,
  })
}

export function fetchSubscriberList(params) {
  return request({
    url: `${v2Host}/website/subscriber/list`,
    method: 'get',
    params,
  })
}

export function fetchActivityList(params) {
  return request({
    url: `${v2Host}/website/activity/list`,
    method: 'get',
    params,
  })
}

// 来源列表
export function referersList() {
  return request({
    url: `${v2Host}/website/subscriber/referers`,
    method: 'get',
  })
}
